import React from "react";
import MainLayout from "../components/layout/MainLayout";

// Blog page component
const BlogPage = () => {
  return (
    <MainLayout title="博客 | GuruGuruHK" url="/blog">
      {/* Full width banner with beige background and added top margin */}
      <div className="w-full bg-[#f9f3eb] p-6">
        {/* Green rectangular banner with text and icon */}
        <div className="max-w-6xl mx-auto relative px-4">
          <div className="w-full h-[80px] relative">
            {/* Green rectangle with rounded corners - reduced height */}
            <div className="absolute left-0 top-0 w-[140px] h-full bg-[#78994C] rounded-br-[30px] shadow-sm">
              {/* Paper icon with rotation - centered in the green rectangle */}
              <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 -rotate-12">
                <svg width="40" height="40" viewBox="0 0 24 24">
                  <rect x="5" y="3" width="14" height="18" rx="2" fill="none" stroke="white" strokeWidth="1.5" />
                  <line x1="8" y1="7" x2="16" y2="7" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  <line x1="8" y1="11" x2="16" y2="11" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  <line x1="8" y1="15" x2="13" y2="15" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
            </div>

            {/* Text positioned outside the green rectangle */}
            <div className="absolute left-[160px] top-1/2 transform -translate-y-1/2">
              <h1 className="text-2xl font-bold text-[#212529]">博客</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Content area with empty state message */}
      <div className="w-full bg-guru-floral-white">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-center items-center py-20">
            <p className="text-xl text-gray-500">沒有資料</p>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default BlogPage;
